/***********************************************************************
Alexander Self
8/23/17
Gang Create form: Basic inline form that describes a form
***********************************************************************/
import React from 'react';
import { NumberInput, Select } from '../../inputs';
import { LOCATIONS } from '../../../constants';

const TeamBuilderForm = ({ onClick }) => {
  return (
    <div className="row">
      <div className="col s12 m12 l4 xl4">
        <NumberInput id={'gang-builder-No'} label={'Team No.'} step={"1.0"} />
      </div>
      <div className="col s12 m12 l4 xl4">
        <Select id={'gang-builder-location'} opts={LOCATIONS} label={'Team Location'} />
      </div>
      <div className="col s12 m12 l4 xl4">
        <div className="gang-create">
          <button className="btn waves-light waves-effect" onClick={onClick}>Create</button>
        </div>
      </div>
    </div>
  );
};

export default TeamBuilderForm;




































/* END */



// WEBPACK FOOTER //
// ./src/components/teams/create/team_builder_form.js